/* MrCOLOMBO Scroll-Reveal Engine v1.1
   Pure Vanilla Intersection Observer. 0kb Dependencies.
   Spec: _dawn-theme/specs/2026-05-21-scroll-reveal-design.md
   v1.1: Class-basierter Auto-Selector statt ID, Footer/Header/UI-Blacklist
*/
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  // Sections die NIE Reveal-Animation bekommen sollen (Header, Footer, fixed/sticky UI, Navigation)
  // filter/subnav/breadcrumb raus: sticky Filterleiste soll nicht faden + transform/will-change wuerde
  // den Containing-Block des fixed Filter-Popups kapern.
  var BLACKLIST_REGEX = /announce|header|footer|whatsapp|back-to-top|cart|drawer|modal|popup|cookie|toast|filter|subnav|breadcrumb/i;

  // Auto-Match: ALLE Content-Sections (mrc + Standard-Dawn) -> site-weiter Reveal auf allen Unterseiten.
  // Header/Footer/UI werden ueber BLACKLIST_REGEX (id/class) zuverlaessig ausgeschlossen.
  var AUTO_SELECTOR = '.shopify-section';

  function isBlacklisted(el) {
    var id = el.id || '';
    var cls = el.className || '';
    return BLACKLIST_REGEX.test(id) || BLACKLIST_REGEX.test(cls);
  }

  function isHidden(el) {
    // Element ist display:none oder hat keine Höhe → kein Reveal
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return true;
    return false;
  }

  // Polyfill-Fallback
  if (typeof IntersectionObserver === 'undefined') {
    var fallback = document.querySelectorAll('.mrc-reveal, .mrc-reveal-stagger, ' + AUTO_SELECTOR);
    for (var k = 0; k < fallback.length; k++) {
      fallback[k].classList.add('is-revealed');
    }
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e.isIntersecting) {
        e.target.classList.add('is-revealed');
        obs.unobserve(e.target);
      }
    }
  }, {
    threshold: 0,
    rootMargin: '0px 0px -80px 0px'
  });

  function process(el) {
    if (!el || el.classList.contains('is-revealed')) return;
    if (isBlacklisted(el)) return;
    if (isHidden(el)) {
      // Hidden Elemente sofort als revealed markieren - falls sie spaeter sichtbar werden
      el.classList.add('is-revealed');
      return;
    }
    if (!el.classList.contains('mrc-reveal') && !el.classList.contains('mrc-reveal-stagger')) {
      el.classList.add('mrc-reveal');
    }
    obs.observe(el);
  }

  function init(root) {
    root = root || document;
    var manual = root.querySelectorAll('.mrc-reveal:not(.is-revealed), .mrc-reveal-stagger:not(.is-revealed)');
    for (var a = 0; a < manual.length; a++) process(manual[a]);
    var auto = root.querySelectorAll(AUTO_SELECTOR);
    for (var b = 0; b < auto.length; b++) process(auto[b]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify Theme-Editor Live-Reload
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
